import axios from 'axios';
import * as Sentry from '@sentry/react';
import { diagnosticTags, trackerOperation } from './tracker-diagnostics';

const reported = new WeakSet();

export function reportApiError(error) {
  if (!error || axios.isCancel(error)) return;
  if (typeof error === 'object' || typeof error === 'function') {
    if (reported.has(error)) return;
    reported.add(error);
  }
  const status = error.response?.status;
  const operation = trackerOperation(error.config) || 'api.request';
  const resultCode = /^\d{5}$/.test(error.response?.data?.resultCode || '') ? error.response.data.resultCode : 'unknown';
  Sentry.captureMessage('Customer API request failed', {
    level: status && status < 500 ? 'warning' : 'error',
    // SDK deduplication otherwise drops distinct failures sharing this call site.
    fingerprint: ['customer-api', operation, String(status || 'network'), resultCode],
    tags: {
      ...diagnosticTags(error.response),
      operation,
      'http.status_code': status || 'network',
      resultCode,
    },
  });
}

export function reportApiRejection(error) {
  reportApiError(error);
  return Promise.reject(error);
}

export function scrubSentryEvent(event) {
  // Page URLs can contain password-reset credentials; console arguments can too.
  delete event.request;
  delete event.user;
  delete event.transaction;
  event.breadcrumbs = event.breadcrumbs?.filter(breadcrumb => breadcrumb.category !== 'console');
  for (const breadcrumb of event.breadcrumbs || []) delete breadcrumb.data;
  return event;
}
